import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './SubscribeForm.css'; // We'll add CSS below

const UnsubscribeForm = () => {
 const [formData, setFormData] = useState({
     firstname: '',
     lastname: '',
     email: '',
   });
   const [errors, setErrors] = useState({});
   const [isLoading, setIsLoading] = useState(false);
 const nameRegex = /^[a-zA-Z\s]+$/;
 const emailRegex = /^\S+@\S+\.\S+$/;
   const validate = () => {
   const newErrors = {};
 
   if (!formData.firstname.trim()) {
     newErrors.firstname = 'First name is required.';
   } else if (!nameRegex.test(formData.firstname)) {
     newErrors.firstname = 'First name can only contain letters and spaces.';
   }
 
   if (!formData.lastname.trim()) {
     newErrors.lastname = 'Last name is required.';
   } else if (!nameRegex.test(formData.lastname)) {
     newErrors.lastname = 'Last name can only contain letters and spaces.';
   }
 
   if (!formData.email) {
     newErrors.email = 'Email is required.';
   } else if (!emailRegex.test(formData.email)) {
     newErrors.email = 'Please enter a valid email address.';
   }
   setErrors(newErrors);
   return Object.keys(newErrors).length === 0;
 };
   const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    setErrors({ ...errors, [name]: '' });
  };
   const handleSubmit = async (e) => {
     e.preventDefault();
     if (!validate()) return;
 
     setIsLoading(true);
 
     try {
       const response = await fetch('https://webvexo.com/unsub_web_mail.php', {
         method: 'POST',
         headers: {'Content-Type': 'application/json' },
         body: JSON.stringify(formData),
       });
 
       if (response.ok) {
         Swal.fire({
           icon: 'success',
           title: 'Subscribed!',
           text: 'Thanks for Unsubscribing. Check your email for confirmation.',
         });
         setFormData({
           firstname: '',
           lastname: '',
           email: '',
         });
       } else {
         Swal.fire({
           icon: 'error',
           title: 'Submission failed',
           text: 'Please try again later.',
         });
       }
     } catch (error) {
       console.error('Error:', error);
       Swal.fire({
         icon: 'error',
         title: 'Network error',
         text: 'Check your connection and try again.',
       });
     } finally {
       setIsLoading(false);
     }
   };

  return (
    <div className="container mb-5 mt-5 margin-top">
      <div className="row d-flex justify-content-center mb-5">
        <p className="text-center fw-bold fs-1 color">Unsubscribe</p>
        <div className="col-md-8">
            <form onSubmit={handleSubmit} className='subscribe-form'>
              <div className='row'>
                  {[
                  { name: 'firstname', label: 'First Name' },
                  { name: 'lastname', label: 'Last Name' },
                  ].map(({ name, label, type = 'text' }) => (
                      <div className="col-md-6 mb-2" key={name}>
                          <input type={type} name={name} value={formData[name]} onChange={handleChange}
                          className={`form-control ${errors[name] ? 'input-error' : ''}`}
                          placeholder={label}
                          />
                          {errors[name] && <small className="text-danger">{errors[name]}</small>}
                      </div>
                  ))}
              </div>
              <div className='row'>
                  {[
                  { name: 'email', label: 'Email', type: 'email' },
                  ].map(({ name, label, type = 'text' }) => (
                      <div className="col-md-12 mb-2" key={name}>
                          <input type={type} name={name} value={formData[name]} onChange={handleChange}
                          className={`form-control ${errors[name] ? 'input-error' : ''}`}
                          placeholder={label}
                          />
                          {errors[name] && <small className="text-danger">{errors[name]}</small>}
                      </div>
                  ))}
              </div>
              <div className="row">
                <div className='col-md-12'>
                  <button type="submit" className="insuba-btn text-center w-50 p-2 fs-5 mt-3" disabled={isLoading}>
                    {isLoading ? (
                        <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" />
                        Submitting...
                        </>
                    ) : (
                        'Unsubscribe'
                    )}
                    </button>
                </div>
              </div>
            </form>
          </div>
      </div>
    </div>
  );
};

export default UnsubscribeForm;
